<template>
  <div class="mb-4">
    <h5 class="mb-2">{{ "canceled" | setText("Отменено") }}</h5>
  </div>
</template>
<script>
export default {
  methods: {},
  data: () => ({}),
  props: ["value", "data", "currentRequest"],
};
</script>
<style>
</style>
 